// extracted by mini-css-extract-plugin
export default {"recordsDisplay":"d15BdwSXSPXhirBRk7ZH","recordsHeader":"jPuoTisWp9wcGvBS6IWQ","recordsMeta":"WZ3aeIzAlN15hsJTttT2"};